export interface AboutTitleLine {
  text: string;
  emphasis?: boolean;
}

export interface AboutFeature {
  label: string;
  title: string;
  description: string;
  tone: "stone" | "dark";
  avatars?: string[];
}

export const aboutData = {
  category: "Custom Manufacturing",

  catalog: "Our Collection",

  expert: {
    text: "Talk to Expert: Arjun Singh",
    image: "/images/about/expert.webp",
  },

  title: [
    { text: "Turning Ideas" },
    { text: "Into Premium" },
    { text: "Products", emphasis: true },
    { text: "For Global Brands!" },
  ] satisfies AboutTitleLine[],

  description:
    "From handcrafted décor and luxury furniture to custom metal, wood, marble, glass, resin, and mixed-material creations, we transform your concepts into premium products. Combining skilled craftsmanship, advanced manufacturing, and international quality standards, we help brands develop collections that stand apart in global markets.",

  image: {
    src: "/home/about/abou-card.webp",
    alt: "Artisan crafting a premium handcrafted product",
  },

  video: {
    src: "/home/about/companytour.mp4",
  },

  featureCards: [
    {
      label: "Custom Development",
      title: "Built Around Your Vision",
      description:
        "Whether you bring a sketch, 3D design, reference image, or an idea, our team transforms it into a commercially successful product with precision and craftsmanship.",
      tone: "stone",
    },
    {
      label: "Global Manufacturing",
      title: "Expert Support & Reliable Production",
      description:
        "From product development to export, our specialists work alongside your team to simplify sourcing, ensure consistent quality, and deliver premium results on time.",
      tone: "dark",
      // avatars: [
      //   "/images/about/avatar-1.webp",
      //   "/images/about/avatar-2.webp",
      //   "/images/about/avatar-3.webp",
      // ],
    },
  ] satisfies AboutFeature[],

  highlight: {
    text: "Every project is backed by a dedicated production team, from first sample to final shipment.",
  },

  stats: [
    { label: "Categories", value: "20+" },
    { label: "Customized", value: "100%" },
    { label: "Export", value: "Global" },
  ],

  footerLinks: [
    "About Us",
    "Manufacturing",
    "Customization",
    "Exports",
    "Contact Us",
  ],

};